import { getAuth, onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import GetUser from "../../Controllers/Users/GetUser";

import "./PageNotFound.css";
const PageNotFound = () => {
  const [UserData, setUserData] = useState();

  const auth = getAuth();
  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const uid = user.uid;
        let resp = await GetUser(uid);

        console.log(resp);
        setUserData(resp);
        // ...
      } else {
        // User is signed out
        // ...
      }
    });
  }, [auth]);

  return (
    <div className="page-not-found-main-wrapper">
      <div className="error-box">
        <h1>404</h1>
        <h3 className="h2 mb-3">
          <i className="fas fa-exclamation-triangle"></i> Oops! Page not found!
        </h3>
        <p className="h4 font-weight-normal">
          The page you requested was not found.
        </p>

        {UserData ? (
          <Link
            to={`user/${UserData?.UserType}/dashboard`}
            className="btn btn-primary"
          >
            Back to Home
          </Link>
        ) : (
          <Link to={`/login`} className="btn btn-primary">
            Back to Home
          </Link>
        )}
      </div>
    </div>
  );
};

export default PageNotFound;
